exports.GAME_ID = '5e04c7ee51023700164c325e',
exports.BD_NAME = 'promo-distrigo';
exports.SERVER_PORT = '3001';


var formID = {} ;
formID["LU_nl"] = "5f465802c81e900017aeea16";
formID["LU_fr"] = "5f465534c81e900017aeea0a";
formID["UK_en"] = "5e314e76050772001721ec61";
formID["NL_nl"] = "601c068c54fb5dc03e009cfd";
formID["DE_de"] = "5f466081c81e900017aeea32";
formID["FR_fr"] = "601818bb52fe785fbc73acfa";
formID["BE_fr"] = "601a6808b452d12cc9cf0af2";
formID["BE_nl"] = "601a67cdb452d12cc9cf0af1";
formID["ES_es"] = "60a61c8d3f1fad001535a4c9";
formID["LU"] = "5f465802c81e900017aeea16";
formID["FR"] = "601818bb52fe785fbc73acfa";

var gameID = {} ;
gameID["BE_fr"] = "629069476111fa0016e8b014";
gameID["BE_nl"] = "6290696a6111fa0016e8b015";
gameID["FR_fr"] = "60acbc8a068fea0015d2e9a7";
gameID["LU_fr"] = "5f4653adc81e900017aeea02";
gameID["LU_nl"] = "5f465765c81e900017aeea15";
gameID["NL_nl"] = "60acc0c1068fea0015d2e9aa";
gameID["DE_de"] = "628e40760340450016376b37";
gameID["ES_es"] = "643dbc32219121502168da42";

exports.FORMS_ID = formID;
exports.GAMES_ID = gameID;